import { Boot } from "./game/scenes/structure/Boot.ts";
import { Preloader } from "./game/scenes/structure/Preloader.ts";
import { MainMenu } from "./game/scenes/structure/MainMenu.ts";
import { GameMain } from "./game/scenes/levels/GameMain.ts";
import { GameMainUIScene } from "./game/scenes/ui/GameMainUIScene.ts";
import { SoundTrackScene } from "./game/scenes/ui/SoundTrackScene.ts";
import { GameWonScene } from "./game/scenes/levels/GameWonScene.ts";
import { GameLostScene } from "./game/scenes/levels/GameLostScene.ts";

export const config: Phaser.Types.Core.GameConfig = {
  title: "REALI7Y OVERRUN",
  type: Phaser.WEBGL,
  parent: "game-container",
  backgroundColor: "#05070a", // RO near-black
  canvasStyle: `display: block; width: 100%; height: 100%;`,
  autoFocus: true,
  clearBeforeRender: true,
  preserveDrawingBuffer: false,
  audio: {
    disableWebAudio: false,
  },
  scale: {
    mode: Phaser.Scale.NONE,
    // autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  physics: {
    default: "arcade",
    arcade: {
      debug: false,
    },
  },
  render: {
    antialias: true,
    antialiasGL: true,
    pixelArt: true,
  },
  callbacks: {
    preBoot: () => {
      //
    },
    postBoot: () => {
      //
    },
  },
  scene: [
    Boot,
    Preloader,
    MainMenu,
    GameMain,
    SoundTrackScene,
    GameMainUIScene,
    GameWonScene,
    GameLostScene,
  ],
};
